import React from 'react';

const CenteredColumn: React.FC = ({ children }) => <div className="text-center">{children}</div>;

export default CenteredColumn;
